<lx-loading-spinner i18n-message message="Loading Accommodations..." [loading]="loading" shadingColor="rgba(0,0,0,0.5)"></lx-loading-spinner>

<lx-section-template [sectionIndex]="sectionIndex" i18n-sectionTitle sectionTitle="Select accommodation">
  <ng-container *ngFor="let accommodation of sectionModel.accommodations; let accommodationIndex = index; let isLast = last">
    <div>
      <lx-form-field-selector
        label="Accommodation"
        i18n-label
        class="qt-form-section__start-new-line form-field__validated-selector-padding"
        [disabled]="!selectedCourses?.length || incompletedCourse"
        [autofill]="selectedCourses?.length && !incompletedCourse"
        [value]="accommodation.code"
        valueExpr="code"
        [itemList]="accommodationIndex === 0 ? accommodationsWithEmptyOption : accommodationOptions[accommodationIndex].items"
        (valueChange)="accommodationChanged(accommodationIndex, $event)"
        [required]="accommodationMandatory"
        [iconValidation]="true"
        [sortCriteria]="[{ property: 'productPosition' }, { property: 'weight' }, { property: 'name' }]"
        [attr.data-qa]="'qt-accommodation-selector-' + accommodationIndex"
      ></lx-form-field-selector>
      <div class="form-field-sections__disclaimer" *ngIf="accommodationOptions[accommodationIndex]?.availability?.length">
        <span i18n>This accommodation is only available for the following dates during your stay:</span>
        <span class="form-field-sections__disclaimer__items" *ngFor="let availDate of accommodationOptions[accommodationIndex].availability">
          {{ availDate.from | lxDate : DateFormat.SHORT_MONTH_NAME }} - {{ availDate.until | lxDate : DateFormat.SHORT_MONTH_NAME }}
        </span>
      </div>
    </div>
    <lx-weeks-selector
      *ngIf="!isWithoutAccommodation(accommodation)"
      label="Duration"
      i18n-label
      class="form-field__validated-selector-padding"
      [disabled]="!accommodation?.code"
      [autofill]="!!accommodation?.code"
      [value]="accommodation.weeks"
      [minWeeks]="accommodationOptions[accommodationIndex].durationMin"
      [maxWeeks]="accommodationOptions[accommodationIndex].durationMax"
      [required]="accommodationIndex === 0"
      [iconValidation]="true"
      (valueChange)="durationChange(accommodationIndex, $event)"
      [attr.data-qa]="'qt-accommodation-duration-selector-' + accommodationIndex"
    ></lx-weeks-selector>

    <lx-date-picker-field
      *ngIf="!isWithoutAccommodation(accommodation) && (datePickerRenderKey[accommodationIndex] ?? 0) >= 0"
      i18n-label
      label="Start Date"
      [placeholder]="accommodation.startDate ? (accommodation.startDate | lxDate : DateFormat.SHORT_MONTH_NAME) : selectPlaceholder"
      class="form-field__validated-selector-padding"
      [disabled]="!accommodation.weeks"
      [dateValue]="accommodation.startDate"
      [dateObject]="accommodation.startDateObject"
      [minDate]="accommodationOptions[accommodationIndex].minDate"
      [maxDate]="accommodationOptions[accommodationIndex].maxDate"
      [defaultDate]="accommodationOptions[accommodationIndex].minDate"
      [disabledDays]="accommodationOptions[accommodationIndex].disabledDays"
      [disabledDates]="accommodationOptions[accommodationIndex].disabledDates"
      [showCalendarIcon]="true"
      [required]="accommodationIndex === 0"
      [iconValidation]="true"
      (dateChanged)="accommodationStartDateChange(accommodationIndex, $event)"
      [attr.data-qa]="'qt-accommodation-start-date-selector-' + accommodationIndex"
    ></lx-date-picker-field>
    <div *ngIf="hasButtons()" class="qt-form-section__start-new-line">
      <lx-button
        text="Delete the accommodation above"
        i18n-text
        [icon]="'pi pi-times'"
        [iconPos]="'before'"
        [iconFill]="true"
        [disabled]="!selectedCourses?.length || sectionModel.accommodations.length < 2"
        [iconRounded]="true"
        [buttonStyle]="'plain-text'"
        [attr.data-qa]="'qt-remove-accommodation-' + accommodationIndex"
        (buttonClick)="removeAccommodationItem(accommodationIndex)"
      >
      </lx-button>
    </div>
    <div *ngIf="isLast && hasButtons()">
      <lx-button
        text="Add an accommodation"
        i18n-text
        [icon]="'pi pi-plus'"
        [iconPos]="'before'"
        [iconFill]="true"
        [disabled]="!selectedCourses?.length || incompletedCourse || !accommodation.startDate || !calculateDurationMax(accommodationIndex + 1)"
        [iconRounded]="true"
        [buttonStyle]="'plain-text'"
        [attr.data-qa]="'qt-add-accommodation-' + accommodationIndex"
        (buttonClick)="addAccommodationItem(accommodationIndex + 1)"
      >
      </lx-button>
    </div>
  </ng-container>
</lx-section-template>
